import { Section } from "@/components/ui/section";
import { Link } from "react-router-dom";



export default function Hero() {


    return (
        
                <Section
            fullHeight={true}
            scrollSnap={true}
            variant="dark"
            backgroundImage="https://hncnzwww.blob.core.windows.net/www/img/auckland-city-cityscape.webp"
            backgroundBlur={2}
            overlayOpacity={30}
            contentPosition="center"
            contained={false}
            padding="lg"
        >
            <div className="relative w-full h-full flex flex-col items-center justify-center">
                <div className="max-w-5xl w-full text-center lg:text-left px-4 md:px-8 lg:px-12">
                    <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 sm:mb-8 leading-none">
                        <div className="animate-fade-in-up delay-200">
                            <span className="inline-block text-white [text-shadow:2px_2px_4px_rgba(0,0,0,0.5)]">Your One-stop</span>
                        </div>
                        <div className="animate-fade-in-up delay-300">
                            <span className="text-harvey-red [text-shadow:2px_2px_4px_rgba(0,0,0,0.5)]">Business Solution</span>
                        </div>
                        <div className="animate-fade-in-up delay-400">
                            <span className="text-white [text-shadow:2px_2px_4px_rgba(0,0,0,0.5)]">Partner</span>
                        </div>
                    </h1>

                    <div className="animate-fade-in-up delay-700 flex flex-col sm:flex-row gap-4 items-center lg:justify-start justify-center mb-16">
                        <Link
                            to="/contact-us/"
                            className="btn max-w-[250px] whitespace-nowrap group bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-semibold px-10 py-7 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                        >
                            <span className="flex items-center gap-2 text-base font-semibold">
                                Start Your Project Today
                                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </span>
                        </Link>
                        <a
                            href="tel:+64800222699"
                            className="btn max-w-[192px] whitespace-nowrap group bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border border-white/30 hover:border-white/50 font-semibold px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 inline-block"
                        >
                            <span className="flex items-center gap-2">
                                0800 222 699
                                <svg className="w-5 h-5 group-hover:rotate-12 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </Section>
    );
}